'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// header

var DetailIcon = function DetailIcon(props) {
    var displayColor = '#d3d3d3';
    if (props.show) {
        displayColor = '#777';
    }
    var display = _react2.default.createElement(
        'div',
        { style: { float: 'right', marginRight: '5px', marginTop: '2px', color: displayColor } },
        _react2.default.createElement('i', { className: 'far fa-file-alt' })
    );

    return display;
};

exports.default = DetailIcon;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/UI/DetailIcon.js
// module id = 799
// module chunks = 0